import React, {useState, createContext, Dispatch, SetStateAction} from "react";
import FormContents from "components/atoms/Form/FormContents";
import TabControl from "components/atoms/TabControl";
import ExecutiveImportCSV from "./ExecutiveImportCSV";
import ExecutiveHistoryImportCSV from "./ExecutiveHistoryImportCSV";
import BlockUI from 'components/molecules/BlockUi';
import { css } from "@emotion/core";
import FormHeader from "components/templates/FormHeader";

type SelectType = "import" | "history";

const SelectType: { [key in SelectType]: SelectType } = {
  import: "import",
  history: "history",
};

type contextType = {
  setIsLoading: Dispatch<SetStateAction<boolean>>
}

export const LoadingContext = createContext<contextType>({} as contextType);

const ExecutiveFormImportLayoutPage: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [selectType, setSelectType] = React.useState<SelectType>(
    SelectType.import
  );

  return (
    <LoadingContext.Provider value={{setIsLoading}}> 
    <BlockUI blocking={isLoading}>
    <FormHeader title="役職インポート" />
    <FormContents customStyle={css({marginTop:'60px'})}>
      <TabControl
        items={[
          {
            value: SelectType.import,
            display: "インポート",
          },
          {
            value: SelectType.history,
            display: "履歴参照",
          },
        ]}
        setValue={setSelectType as (arg: string) => void}
        currentValue={selectType}
        customStyle={css({paddingTop:'16px'})}
      />
      {selectType === SelectType.import && <ExecutiveImportCSV/>}
      {selectType === SelectType.history && <ExecutiveHistoryImportCSV/>}
    </FormContents>
    </BlockUI>
    </LoadingContext.Provider>
  );
};

export default ExecutiveFormImportLayoutPage;
